<script setup lang="ts">
import ImageSlider from './ImageSlider.vue'
import WaypointVisualizer from './waypointVisualizer/WaypointVisualizer.vue'

interface PropTypes {
  pushImageRoute: (imageUuid: string) => void
}

const props = defineProps<PropTypes>()
</script>

<template>
  <div class="relative h-full grid grid-rows-[minmax(80%,_90%)_auto] grid-cols-1">
    <div>
      <WaypointVisualizer :push-image-route="props.pushImageRoute"/>
    </div>
    <div class="z-10 bg-stone">
      <ImageSlider :push-image-route="props.pushImageRoute" />
    </div>
  </div>
</template>
